import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  LeadAttributeRequest,
  LeadAttributeResponse,
  PageResponse
} from '../models/lead-attribute.model';

@Injectable({
  providedIn: 'root'
})
export class LeadAttributeApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  getAttributes(businessId: number, page = 0, size = 100): Observable<LeadAttributeResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<LeadAttributeResponse>>(`${this.apiUrl}/lead-attributes`, { params })
      .pipe(map(res => res.content));
  }

  getAttributeById(id: number, businessId: number): Observable<LeadAttributeResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<LeadAttributeResponse>(`${this.apiUrl}/lead-attributes/${id}`, { params });
  }

  createAttribute(attribute: LeadAttributeRequest): Observable<LeadAttributeResponse> {
    return this.http.post<LeadAttributeResponse>(`${this.apiUrl}/lead-attributes`, attribute);
  }

  updateAttribute(id: number, attribute: LeadAttributeRequest): Observable<LeadAttributeResponse> {
    return this.http.put<LeadAttributeResponse>(`${this.apiUrl}/lead-attributes/${id}`, attribute);
  }

  deleteAttribute(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/lead-attributes/${id}`, { params });
  }
}
